import React from "react"
import styles from "./detail.module.css"
import { formatDateAndTime } from "../../utils/utils"

const Details = ({ userDetails }) => {
   return (
      <div className={styles.container}>
         <div className={styles.leftContainer}>
            <div className={styles.columns}>
               <p>Username: </p>
               <p>Email: </p>
            </div>
            <div>
               <p>{userDetails?.username || "--"}</p>
               <p>{userDetails?.email || "--"}</p>
            </div>
         </div>
         <div className={styles.rightContainer}>
            <div className={styles.columns}>
               <p>Time Created:</p>
               <p>KYC Status:</p>
            </div>
            <div>
               <p>{formatDateAndTime(userDetails?.createdAt || "--")}</p>
               <p>{userDetails?.status || "--"}</p>
            </div>
         </div>
      </div>
   )
}


export default Details
